import _ from "lodash";
import React, { useState } from "react";
import { Button, Col, Input, Row, Table, Card, CardBody } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { api, dateHelpers } from "../utils";
import { toast } from "react-toastify";
import { InvoiceAndPackingList, ConsignedInventoryInquiry } from "./";
import classNames from "classnames";
import { ItemDropdownMenu } from "../components";

export default function InventoryTrackingTools() {
   const [showA, setShowA] = useState(true);
   const [showB, setShowB] = useState(false);
   const [showC, setShowC] = useState(false);
   const [workOrder, setWorkOrder] = useState(null);
   const [screenForm, setScreenForm] = useState({
      payload: {
         caseBarCode: 0,
         caseId: "",
         caseBarCodeChecked: false
      },
      otherProperty: "",
      otherProperty1: "",
   });

   const GetWorkOrderCase = () => {
      let payload = Object.assign({}, screenForm.payload);

      if (payload.caseBarCodeChecked) {
         payload.caseId = "";
         if (!payload.caseBarCode) {
            toast.error("Case bar code is required value");
            return;
         }
      } else {
         payload.caseBarCode = 0;
         if (!payload.caseId) {
            toast.error("Case number code is required value");
            return;
         }
      }
      //"The Barcode you entered was canceled! The case information listed below was looked up from the old barcode information."
      return api
         .post("Quality/WorkOrderCaseLookUp", payload)
         .then((r) => {
            if (!r.data.success) {
               throw new Error(r.data.message);
            }
            if (r.data.success) {
               if (r.data.workOrderCanceled) {
                  toast.success(
                     "The Barcode you entered was canceled! The case information listed below was looked up from the old barcode information."
                  );
                  setWorkOrder(r.data.workOrderCanceled);
               }
               if (r.data.workOrder) {
                  setWorkOrder(r.data.workOrder);
               } else {
                  toast.info("The operation was successful, but the server didn't return an OK message. Please notify your admin.");
               }
            }
         })
         .catch((error) => {
            toast.error(error);
            api.catchHandler(error);
         });
      // .finally
   };

   const onChange = (property, value, copy = null) => {
      if (copy === null) copy = _.cloneDeep(screenForm);
      _.set(copy, property, value);
      setScreenForm(copy);
      return;
   };

   const onChangeRegexFormat = (paragraph, propertyName) => {
      if (typeof paragraph != "string") return 0;
      const regex = /[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)/;
      const found = paragraph.match(regex);
      if (found != null && parseFloat(found[0]) >= 0) {
         let value = parseFloat(found[0]);
         onChange(propertyName, value);
      } else {
         toast.warning(
            `your number ${paragraph} is not formatted correctly please try again`
         );
      }
   };

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   return (
      document.title = `Inventory Tracking Tools`,
      <DesktopContainer screenName={"Inventory Tracking Tools"}>
         <div className="filter-header sticky-top">
            <div className="dashboard-button-container">
               <Button
                  children={"Case Lookup"}
                  className="filter-button"
                  onClick={() => setShowA(!showA)}
                  active={showA}
               />
               <Button
                  children={"Consigned/Shipment Inquiry"}
                  className="filter-button"
                  onClick={() => setShowC(!showC)}
                  active={showC}
               />
               <Button
                  children={"Invoice/Packing Inquiry"}
                  className="filter-button"
                  onClick={() => setShowB(!showB)}
                  active={showB}
               />
            </div>
         </div>
         {showA ? (
            <Card className="dashboard-card">
               <CardBody>
                  <Row>
                     <Col xs={12} className="text-center">
                        <h4>Work Order Case Lookup</h4>
                     </Col>
                  </Row>
                  <hr />
                  <Row className="mt-2 justify-content-center">
                     <Col xs="2" style={{ textAlign: "right", marginRight: "5px", }}>
                        <label>Case Number</label>
                        <input
                           type="radio"
                           id="WorkOrderCases"
                           className="ms-3"
                           name="orderType"
                           defaultChecked
                           onChange={() => onChange("payload.caseBarCodeChecked", false)}
                        />
                     </Col>
                     <Col xs={{ size: 4, offset: -2 }}>
                        <Input
                           type="text"
                           name={"CaseNumber"}
                           value={screenForm.payload.caseId}
                           disabled={screenForm.payload.caseBarCodeChecked}
                           onChange={(e) => { onChange("payload.caseId", e.target.value); }}
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3 justify-content-center">
                     <Col xs="2" style={{ textAlign: "right", marginRight: "5px", }}>
                        <label>Case Barcode</label>
                        <input
                           type="radio"
                           id="WorkOrderCases"
                           className="ms-3"
                           name="orderType"
                           onChange={() => onChange("payload.caseBarCodeChecked", true)}
                        />
                     </Col>
                     <Col xs={{ size: 4, offset: -2 }}>
                        <Input
                           type="text"
                           name={"CaseBarCode"}
                           value={screenForm.payload.caseBarCode}
                           onChange={(e) => {
                              onChangeRegexFormat(e.target.value, "payload.caseBarCode");
                           }}
                           disabled={!screenForm.payload.caseBarCodeChecked}
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3 mb-5 justify-content-center">
                     <Col xs={{ size: 2, offset: 3 }}>
                        <Button
                           className="shredButton"
                           onClick={() => GetWorkOrderCase()}
                        >
                           LOOK UP CASE INFORMATION
                        </Button>
                     </Col>
                  </Row>

                  {workOrder && (
                     <div className="bg-primary p-4">
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5 children="Item:" className="float-end text-white" />
                           </Col>
                           <ItemDropdownMenu
                              itemNumber={workOrder.itemNumber}
                              itemDescription={workOrder.itemWithDesc}
                              // attachmentCount={cmp.itemAttachmentCount}
                              // bomReplace
                              custom
                           />
                        </Row>

                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5 children="Status:" className="float-end text-white" />
                           </Col>
                           <Col>
                              <h5
                                 children={workOrder.caseStatus}
                                 className="float-start text-white"
                              />
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Work Order:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col>
                              <h5
                                 children={workOrder.workOrderNumber}
                                 className="float-start boldedOrange"
                                 onClick={() => toast.info("Coming Soon...")}
                              />
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5 children="Lot #:" className="float-end text-white" />
                           </Col>
                           <Col>
                              <h5
                                 children={workOrder.lotNumber}
                                 className="float-start text-white"
                              />
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Active Barcode:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col>
                              <h5
                                 children={
                                    workOrder.caseBarCode?.barcodeNumber ??
                                    workOrder.activeBarCodeId
                                 }
                                 className="float-start text-white"
                              />
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Inactive Barcodes:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col>
                              {_.isEmpty(workOrder.inactiveCaseBarcodes) ? (
                                 <h5
                                    children={"No Inactive BarCodes Found"}
                                    className="float-start text-white"
                                 />
                              ) : null}
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Production Date/By:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col>
                              <h5
                                 children={
                                    Date.parse(workOrder.productionDate) === -62135579038000
                                       ? "N/A"
                                       : dateHelpers.toLongDateString(workOrder.productionDate)
                                 }
                                 className="float-start text-white"
                              />
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Fullfilled Date/By:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col>
                              <h5
                                 children={
                                    Date.parse(workOrder.fulfilledDate) === -62135579038000
                                       ? "N/A"
                                       : dateHelpers.toLongDateString(workOrder.fulfilledDate)
                                 }
                                 className="float-start text-white"
                              />
                           </Col>
                        </Row>
                        <Row>
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Disassembled Date/By:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col>
                              <h5
                                 children={
                                    Date.parse(workOrder.disassembledDate) === -62135579038000
                                       ? "N/A"
                                       : dateHelpers.toLongDateString(workOrder.disassembledDate)
                                 }
                                 className="float-start text-white"
                              />
                           </Col>
                        </Row>

                        <Row className="mb-3">
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Weights & Quantities:"
                                 className="float-end text-white"
                              />
                           </Col>

                           <Col xxl={6}>
                              <Card>
                                 <CardBody>
                                    <Table size="sm" className="data-table striped">
                                       <thead className="table-header">
                                          <tr>
                                             <th children={"GROSS"} />
                                             <th children={"NET"} />
                                             <th children={"TARE"} />
                                             <th children={"PALLET WEIGHT"} />
                                             <th children={"CASE QTY"} />
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td
                                                className={"data-cell"}
                                                children={workOrder.grossWeight}
                                             />
                                             <td
                                                className={"data-cell"}
                                                children={workOrder.netWeight}
                                             />
                                             <td
                                                className={"data-cell"}
                                                children={workOrder.tareWeight}
                                             />
                                             <td
                                                className={"data-cell"}
                                                children={workOrder.palletWeight}
                                             />
                                             <td
                                                className={"data-cell"}
                                                children={workOrder.caseQty}
                                             />
                                          </tr>
                                       </tbody>
                                    </Table>
                                 </CardBody>
                              </Card>
                           </Col>
                        </Row>

                        <Row className="mb-5">
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", }}>
                              <h5
                                 children="Adjustment Info:"
                                 className="float-end text-white"
                              />
                           </Col>
                           <Col xxl={6}>
                              {_.isEmpty(workOrder.invAdjInfo) ? (
                                 <h5
                                    children={"No Adjustment Info Found"}
                                    className="float-start text-white"
                                 />
                              ) : (
                                 <Card>
                                    <CardBody>
                                       <Table size="sm" className="data-table striped">
                                          <thead className="table-header">
                                             <tr>
                                                <th children={"Item"} />
                                                <th children={"Loc"} />
                                                <th children={"UOFM"} />
                                                <th children={"Qty"} />
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {_.map(workOrder.invAdjInfo, (x, index) => {
                                                return (
                                                   <tr
                                                      key={index}
                                                      className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                                   >
                                                      <td className="sort-handle">
                                                         <a rel="noreferrer"
                                                            href={`/inventoryDashboard/${JSON.stringify(
                                                               {
                                                                  value: x.itemNumber,
                                                                  label: x.itemWithDesc,
                                                               }, replacer
                                                            )}`}
                                                            target="_blank"
                                                            className="styledAnchor"
                                                         >
                                                            {x.itemWithDesc}
                                                         </a>
                                                      </td>
                                                      <td className="data-cell">{x.location}</td>
                                                      <td className="data-cell">{x.uofm}</td>
                                                      <td
                                                         className={classNames("data-cell", {
                                                            "text-brightRed": x.qty < 0,
                                                         })}
                                                      >
                                                         {x.qty}
                                                      </td>
                                                   </tr>
                                                );
                                             })}
                                          </tbody>
                                       </Table>
                                    </CardBody>
                                 </Card>
                              )}
                           </Col>
                        </Row>
                     </div>
                  )}
               </CardBody>
            </Card>
         ) : (
            false
         )}
         {showB ? (
            <Card className="dashboard-card">
               <CardBody>
                  <div>
                     <span className="h2 me-2">Invoice and Packing List Inquiry</span>
                  </div>
                  <hr />
                  <Row>
                     <Col>
                        <InvoiceAndPackingList short />
                     </Col>
                  </Row>
               </CardBody>
            </Card>
         ) : (
            false
         )}
         {showC ? (
            <Card className="dashboard-card">
               <CardBody>
                  <div>
                     <span className="h2 me-2">
                        Consigned Inventory Shipment Inquiry
                     </span>
                  </div>
                  <hr />
                  <Row>
                     <Col>
                        <ConsignedInventoryInquiry short />
                     </Col>
                  </Row>
               </CardBody>
            </Card>
         ) : (
            false
         )}
      </DesktopContainer>
   );
}
